<template>
  <v-row justify="center">
    <v-col md="12" col="12">
      <v-card class="rounded-lg card-info-reserve">
        <v-card-title v-html="$t('booking.tu_reserva')"/>
        <v-card-text v-if="reservation.hourv2.draft">
          <h4 v-html="getLabels('IMPORTANTLABEL')" />
          <span v-html="$t('booking.draft_label_alert')" />
        </v-card-text>
        <v-divider />
        <v-card-text v-if="getCobros">
          <h4 v-html="$t('booking.cobros')" />
          <div v-if="reservation.siteservice_label && reservation.siteservice_label.label.length">
            <span>{{ labelServiceReservation }}</span>
          </div>
          <div v-for="(item,index) in labelReservation" :key="item">
            <span>{{ labelReservation[index] }}</span>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-text>
          <h4 v-html="$t('booking.invitados')" />
          <span>{{ reservation.cuantos }} {{ reservation.cuantos > 1 ? $t('booking.personas_label'):$t('booking.persona_label') }}</span>
          <h4 v-html="$t('booking.booking_date2_label')" />
          <span v-html="reservation.date.label" />
          <h4 v-html="$t('booking.booking_hour_label')" />
          <span v-html="$t('booking.de_label') + ' ' + reservation.hourv2.label" />
        </v-card-text>
        <v-divider />
        <div v-if="flatZoneCouseDescription">
          <v-card-text>
            <div v-if="reservation.cause">
              <h4 v-html="$t('booking.booking_reason')" />
              <span v-html="reservation.cause" />
            </div>
            <div v-if="reservation.zone_label" >
              <h4 v-html="$t('booking.booking_zone_label')" />
              <span v-html="getZoneLabel" />
            </div>
            <div v-if="reservation.descriptionProduct">
              <h4 v-html="$t('booking.servicio_seleccionado')" />
              <span v-html="reservation.descriptionProduct" />
            </div>
          </v-card-text>
          <v-divider />
        </div>
        <v-card-text v-if="bookInfo.deductible > 0">
          <h4 v-html="$t('booking.deductible')" />
          <span>{{ $n(bookInfo.deductible, 'currency', instance.locale) }}</span>
        </v-card-text>
        <v-divider />
        <v-card-text v-if="reservation.precheckout">
          <h4 v-html="$t('booking.total')" />
          <span>{{ labelTotalReservatioPrecheckout }}</span>
        </v-card-text>
        <div v-if="!reservation.hourv2.draft">
          <v-divider />
          <reserve-payment-method-form
            v-if="bookPurchaseId.toString().length"
            :purchase="reservation.purchase"
            class="pb-0 reserve-payment-method-form"
          />
        </div>
      </v-card>
    </v-col>
    <v-footer app class="pa-0">
      <v-container v-if="reservation.hourv2.draft" class="body-button-nextpass">
        <v-btn
          class="button-nextpass text-capitalize"
          color="primary"
          large block
          @click="draft = true"
          v-html="$t('booking.wait_list_label')"
        />
      </v-container>
      <v-container v-else class="body-button-nextpass this here">
        <v-btn
          class="button-nextpass text-capitalize"
          color="primary"
          large block
          @click="validateForm()"
          v-html="labelTotalButton"
        />
      </v-container>
    </v-footer>
    <v-bottom-sheet v-model="display_message">
        <v-sheet class="text-center display-message" height="200px">
          <v-btn
            class="mt-6"
            text color="red"
            @click="display_message = !display_message"
            v-html="$t('messages_error.continuar')"
          />
          <div class="py-3" v-html="message_error" />
        </v-sheet>
    </v-bottom-sheet>
    <v-dialog
      v-model="draft"
      scrollable persistent :overlay="false"
      max-width="500px" transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          {{ getLabels('wait_list') }}
          <v-spacer></v-spacer>
          <v-btn fab small icon @click="closeModalWaitList()">
            <v-icon color="red">fa-light fa-xmark</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="draft-info">
            <span v-html="$t('booking.success_label_wait_list')" />
          </div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            class="text-capitalize"
            color="primary" small
            v-html="'Finalizar'"
            @click="closeWaitLis()"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import { profile } from "../../services/profile";
import ReservePaymentMethodForm from "../precheckout/PaymentMethodForm.vue";

export default {
  name: 'InfoReserve',
  components: { ReservePaymentMethodForm },
  props: {
    reservation: Object,
    branch: Object,
    instance: Object,
    supplier: Object,
    agreement: Boolean
  },
  computed: {
    ...mapState('bookings', ["bookInfo","bookPurchaseId"]),
    ...mapGetters('customer', ["price_currency_locale", "getLabels"]),
    labelServiceReservation() {
      let labelData = "";
      if (this.reservation.siteservice_label.label.length) labelData = this.reservation.siteservice_label.label;
      return labelData;
    },
    labelReservation() {
      let labelBook = [];
      if(this.reservation.hourv2.reservation_modes.length) {
        this.reservation.hourv2.reservation_modes.map(item => {
          if(item.code === 'cover') labelBook.push(
              this.$t('booking.value_cover') + `  ` +
              this.$n(item.reservation_fee,'currency',this.instance.locale)
            );
          if(item.code === 'table') labelBook.push(
              this.$t('booking.value_fix') + `  ` +
              this.$n(item.reservation_fee,'currency',this.instance.locale)
            );
          if(item.code === 'person') labelBook.push(
              this.$t('booking.value_person') + `  ` + this.reservation.cuantos + ' ' + this.$t('common.persons_label') + ' ' +
              this.$n(item.reservation_fee,'currency',this.instance.locale)
          );
        });
      };
      return labelBook;
    },
    getZoneLabel() {
      let label = this.reservation.zone_label;
      const idx = this.bookInfo.reservation_fee_detail.findIndex(item => item.code === 'zone');
      if(idx > -1 ){
        const zoneObj = this.bookInfo.reservation_fee_detail[idx];
        if(Number(zoneObj.total) > 0) label = `${this.reservation.zone_label} ${this.$i18n.n(zoneObj.total, "currency", this.instance.locale)}`
      }
      return label;
    },
    getCobros () {
      return (this.reservation.hourv2.reservation_modes.length || this.reservation.siteservice_label && this.reservation.siteservice_label.label.length)
    },
    flatZoneCouseDescription () {
      return (this.reservation.cause || this.reservation.zone_label || this.reservation.descriptionProduct)
    },
    labelTotalReservatioPrecheckout () {
      return this.$n(this.reservation.precheckout.total, 'currency', this.instance.locale);
    },
    labelTotalButton () {
      return `${this.$t('order.pay_label')} ${this.price_currency_locale(this.reservation.precheckout.total)}`
    }
  },
  data: () => ({
    display_message: false,
    message_error: "",
    show_policies: false,
    processing: false,
    error: {paymentMethod: false},
    validate: {paymentMethod: false},
    rules: {
      required: v => !!v || "Campo requerido"
    },
    draft: false
  }),
  methods: {
    ...mapMutations('bookings', ["SetBookInfo", "SetBookPurchaseId"]),
    closeWaitLis() {
      this.$router.go(-1);
      this.draft = false;
    },
    closeBox() {
      this.show_policies = false;
    },
    validateForm() {
      if (this.processing) return;
      if (this.agreement) {
        this.error.paymentMethod = false;
        this.sendInfo();
        if(this.bookPurchaseId !== null) this.ValidatePaymentMethod();
        this.CheckAllForm();
      }else {
        this.error.paymentMethod = true;
        this.CheckAllForm();
      };
    },
    CheckAllForm() {
      if (this.error.paymentMethod) {
        this.message_error = this.$t("messages_error.metodo_pago");
        this.display_message = true;
        return;
      };
    },
    ValidatePaymentMethod() {
      this.validate.paymentMethod = false;
      this.error.paymentMethod = false;
      if (this.reservation.purchase.payment_method_original.toString().length === 0) {
        this.error.paymentMethod = true;
      }else {
        this.validate.paymentMethod = true,
        this.reservation.purchase.validate_contact = true;
      };
    },
    sendInfo() {
      this.overlay = false;
      if (this.bookPurchaseId !== null) {
        this.precheckout();
      } else {
        this.$router.push({
          name: "BookInfo",
          params: {
            id: `${this.bookInfo.id}`,
            token: `${this.bookInfo.token}`,
            supplier_id: `${this.$route.params.supplier_id}`
          }
        });
      };
    },
    precheckout() {
      this.reservation.purchase.payment_method = this.reservation.purchase.payment_method_original;
      if (this.reservation.purchase.payment_method_original === "dataphone") {
        this.reservation.purchase.payment_method = "dvp";
        this.reservation.purchase.cash_config = { tipe: "dataphone", cash_amount: 0 };
      };
      profile.saveProfile();
      this.ProcessRedirect(this.reservation.precheckout);
    },
    ProcessRedirect(response) {
      if (
        this.reservation.purchase.payment_method === "pse" ||
        this.reservation.purchase.payment_method === "tc" ||
        this.reservation.purchase.payment_method === "other"
      ) {
        this.$router.push({
          name: "Checkoutv2",
          params: {
            supplier_id: this.supplier.slug,
            id: response.id
          }
        });
      } else if (this.reservation.purchase.payment_method === "webcheckout") {
        this.$router.push({
          name: "Webcheckout",
          params: {
            supplier_id: this.supplier.slug,
            order_id: response.id
          }
        });
      };
    }
  }
}
</script>

<style scoped lang="scss">
  .display-message {
    font-family: 'Poppins', sans-serif !important;
  }
  .card-info-reserve {
    font-family: 'Poppins', sans-serif !important;
    .v-card__title {
      font-weight: 900 !important;
    }
  }
  .body-button-nextpass {
    font-family: 'Poppins', sans-serif !important;
    display: flex;
    flex-direction: column;
    height: 6rem;
    .button-nextpass {
      margin: 0 !important;
      height: 2.8rem !important;
      border-radius: 10px !important;
    }
  }
</style>
